module.exports = __webpack_public_path__ + "img/cross-close.27ad7eb4.svg";